import { render, staticRenderFns } from "./eliminar.vue?vue&type=template&id=7530ddf1&scoped=true&"
import script from "./eliminar.vue?vue&type=script&lang=js&"
export * from "./eliminar.vue?vue&type=script&lang=js&"
import style0 from "./eliminar.vue?vue&type=style&index=0&id=7530ddf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7530ddf1",
  null
  
)

export default component.exports